import sheenchair from "../assets/models/sheenchair.glb";
import ioschair from "../assets/models/sheenchair.usdz";
import painting from "../assets/models/Painting.glb";
import iospainting from "../assets/models/Painting.usdz";
import car from "../assets/models/car.glb";
import ioscar from "../assets/models/car.usdz";
import car1 from "../assets/models/Car1.glb";
import ioscar1 from "../assets/models/Car1.usdz";
import OfficeChair from "../assets/models/OfficeChair.glb";
import OfficeChairUsdz from "../assets/models/OfficeChair.usdz";
import pot from "../assets/models/pot.glb";
import potUsdz from "../assets/models/pot.usdz";

// New models from your directory
import bed from "../assets/models/bed.glb";
import bedUsdz from "../assets/models/Bed.usdz";
import bugatti from "../assets/models/bugatti.glb";
import bugattiUsdz from "../assets/models/bugatti.usdz";
import carpet from "../assets/models/game_ready_carpet.glb";
import carpetUsdz from "../assets/models/Game_Ready_Carpet.usdz";
import mirror from "../assets/models/mirror_a.glb";
import mirrorUsdz from "../assets/models/Mirror_A.usdz";
import macbook from "../assets/models/macbook_laptop.glb";
import macbookUsdz from "../assets/models/MacBook_Laptop.usdz";
import simpleDiningTable from "../assets/models/simple_dining_table.glb";
import simpleDiningTableUsdz from "../assets/models/Simple_dining_table.usdz";
import sofa from "../assets/models/sofa.glb";
import sofaUsdz from "../assets/models/sofa.usdz";
import table from "../assets/models/table.glb";
import tableUsdz from "../assets/models/Table.usdz";
import tableLamp from "../assets/models/table_lamp_01.glb";
import tableLampUsdz from "../assets/models/Table_Lamp_01.usdz";
import bookSelf from "../assets/models/book_self.glb";
import bookSelfUsdz from "../assets/models/Book_Self.usdz";
import woodenAlmirah from "../assets/models/wooden_almirah.glb";
import woodenAlmirahUsdz from "../assets/models/Wooden_Almirah.usdz";
import officeChairNew from "../assets/models/office_chair.glb";
import officeChairNewUsdz from "../assets/models/Office_chair.usdz";

// ✅ NEW: 3 Additional Models
import kriegerdenkmal from "../assets/models/kriegerdenkmal.glb";
import kriegerdenkmalUsdz from "../assets/models/Kriegerdenkmal.usdz";
import washingMachine from "../assets/models/drum_washing_machine.glb";
import washingMachineUsdz from "../assets/models/Drum_washing_machine.usdz";
import refrigerator from "../assets/models/refrigerador.glb";
import refrigeratorUsdz from "../assets/models/Refrigerador.usdz";

const productItems = [
  {
    id: 1,
    name: "Sheen Chair",
    modelSrc: sheenchair,
    iOSSrc: ioschair,
    category: "Furniture",
    color: "Orange",
    price: "99.99",
    rating: "4.5",
    description: "Comfortable mid-century modern chair with premium fabric upholstery",
    image: "/chair1.jpg",
    inStock: true,
    verified: true,
    colorOptions: ["Orange", "Red", "Blue", "Gray"],
    annotations: [
      {
        title: "comfortable-back",
        slot: "hotspot-1",
        position: "0.011597651675006926m 0.5744572599492905m -0.1383899854988515m",
        normal: "0.028332494851243895m 0.2137467602998606m 0.9764781575625839m",
        orbit: "10.89188deg 119.9775deg 0.03543022m",
        target: "-0.1053838m 0.01610652m 0.1076345m"
      }, 
      {
        title: "comfortable-seat",
        slot: "hotspot-2",
        position: "0.008754174027053235m 0.3513235856998005m 0.1658749505478343m",
        normal: "-0.30988561688489596m 0.9507625837296717m -0.004627507703580716m",
        orbit: "10.89188deg 119.9775deg 0.03543022m",
        target: "-0.1053838m 0.01610652m 0.1076345m"
      },
    ]
  },
  {
    id: 2,
    name: "Executive Office Chair",
    modelSrc: OfficeChair,
    iOSSrc: OfficeChairUsdz,
    category: "Furniture",
    color: "Black",
    price: "149.99",
    rating: "4.8",
    description: "Ergonomic office chair with lumbar support and adjustable height",
    image: "/chair2.jpg",
    inStock: true,
    verified: true,
    colorOptions: ["Black", "Gray", "Brown"],
    annotations: [
      {
        title: "comfortable-back",
        slot: "hotspot-1",
        position: "0.011597651675006926m 0.5744572599492905m -0.1383899854988515m",
        normal: "0.028332494851243895m 0.2137467602998606m 0.9764781575625839m",
        orbit: "10.89188deg 119.9775deg 0.03543022m",
        target: "-0.1053838m 0.01610652m 0.1076345m"
      }, 
      {
        title: "comfortable-seat",
        slot: "hotspot-2",
        position: "0.008754174027053235m 0.3513235856998005m 0.1658749505478343m",
        normal: "-0.30988561688489596m 0.9507625837296717m -0.004627507703580716m",
        orbit: "10.89188deg 119.9775deg 0.03543022m",
        target: "-0.1053838m 0.01610652m 0.1076345m"
      },
    ]
  },
  {
    id: 3,
    name: "Decorative Pot Plant",
    modelSrc: pot,
    iOSSrc: potUsdz,
    category: "Decor",
    color: "Brown",
    price: "49.99",
    rating: "4.3",
    description: "Beautiful ceramic pot with artificial plant, perfect for any room",
    image: "/pot.jpg",
    inStock: true,
    verified: true,
    colorOptions: ["Brown", "White", "Black", "Terracotta"],
    annotations: [
      {
        title: "pot-structure",
        slot: "hotspot-1",
        position: "0.008754174027053235m 0.3513235856998005m 0.1658749505478343m",
        normal: "-0.30988561688489596m 0.9507625837296717m -0.004627507703580716m",
        orbit: "10.89188deg 119.9775deg 0.03543022m",
        target: "-0.1053838m 0.01610652m 0.1076345m"
      }
    ]
  },
  {
    id: 4,
    name: "Wooden Frame Painting",
    modelSrc: painting,
    iOSSrc: iospainting,
    category: "Art",
    color: "Brown",
    price: "79.99",
    rating: "4.6",
    description: "Rustic wooden frame with abstract canvas art",
    image: "/painting.jpg",
    inStock: true,
    verified: true,
    colorOptions: ["Natural Wood", "Dark Brown", "Black", "White"],
    annotations: [
      {
        title: "wooden-frame",
        slot: "hotspot-1",
        position: "0.011597651675006926m 0.5744572599492905m -0.1383899854988515m",
        normal: "0.028332494851243895m 0.2137467602998606m 0.9764781575625839m",
        orbit: "10.89188deg 119.9775deg 0.03543022m",
        target: "-0.1053838m 0.01610652m 0.1076345m"
      }, 
      {
        title: "pure-canvas",
        slot: "hotspot-2",
        position: "0.008754174027053235m 0.3513235856998005m 0.1658749505478343m",
        normal: "-0.30988561688489596m 0.9507625837296717m -0.004627507703580716m",
        orbit: "10.89188deg 119.9775deg 0.03543022m",
        target: "-0.1053838m 0.01610652m 0.1076345m"
      },
    ]
  },
  {
    id: 5,
    name: "Compact Car",
    modelSrc: car,
    iOSSrc: ioscar,
    category: "Vehicle",
    color: "Blue",
    price: "99.99",
    rating: "4.7",
    description: "Modern compact car with sleek design and efficient performance",
    image: "/car.jpg",
    inStock: true,
    verified: true,
    colorOptions: ["Blue", "Red", "White", "Black", "Silver"],
    annotations: [
      {
        title: "plastic-structure",
        slot: "hotspot-1",
        position: "-0.0036662781627494825m 0.11165170707633758m 0.07931578568217246m",
        normal: "-0.007882343763611447m 0.9530143214961644m 0.30282267365571863m",
        orbit: "10.89188deg 119.9775deg 0.03543022m",
        target: "-0.1053838m 0.01610652m 0.1076345m"
      }, 
      {
        title: "glossy-color",
        slot: "hotspot-2",
        position: "-0.09202904871903242m 0.05133736629679797m 0.0013477452825590153m",
        normal: "-0.9976942525197127m 0.061837681663106964m 0.027969261979253417m",
        orbit: "10.89188deg 119.9775deg 0.03543022m",
        target: "-0.1053838m 0.01610652m 0.1076345m"
      },
    ]
  },
  {
    id: 6,
    name: "Sport Car",
    modelSrc: car1,
    iOSSrc: ioscar1,
    category: "Vehicle",
    color: "Red",
    price: "99.99",
    rating: "4.9",
    description: "High-performance sports car with aerodynamic design",
    image: "/sportcar.jpg",
    inStock: true,
    verified: true,
    colorOptions: ["Red", "Yellow", "Black", "White"],
    annotations: [
      {
        title: "plastic-structure",
        slot: "hotspot-1",
        position: "0.011597651675006926m 0.5744572599492905m -0.1383899854988515m",
        normal: "0.028332494851243895m 0.2137467602998606m 0.9764781575625839m",
        orbit: "10.89188deg 119.9775deg 0.03543022m",
        target: "-0.1053838m 0.01610652m 0.1076345m"
      }, 
      {
        title: "glossy-color",
        slot: "hotspot-2",
        position: "0.008754174027053235m 0.3513235856998005m 0.1658749505478343m",
        normal: "-0.30988561688489596m 0.9507625837296717m -0.004627507703580716m",
        orbit: "10.89188deg 119.9775deg 0.03543022m",
        target: "-0.1053838m 0.01610652m 0.1076345m"
      },
    ]
  },
  {
    id: 7,
    name: "Luxury Bugatti",
    modelSrc: bugatti,
    iOSSrc: bugattiUsdz,
    category: "Vehicle",
    color: "Silver",
    price: "99.99",
    rating: "5.0",
    description: "Premium luxury sports car with iconic Bugatti design and superior craftsmanship",
    image: "/bugatti.jpg",
    inStock: true,
    verified: true,
    colorOptions: ["Silver", "Black", "Blue", "Red"],
    annotations: [
      {
        title: "aerodynamic-body",
        slot: "hotspot-1",
        position: "0.011597651675006926m 0.5744572599492905m -0.1383899854988515m",
        normal: "0.028332494851243895m 0.2137467602998606m 0.9764781575625839m",
        orbit: "10.89188deg 119.9775deg 0.03543022m",
        target: "-0.1053838m 0.01610652m 0.1076345m"
      }, 
      {
        title: "luxury-interior",
        slot: "hotspot-2",
        position: "0.008754174027053235m 0.3513235856998005m 0.1658749505478343m",
        normal: "-0.30988561688489596m 0.9507625837296717m -0.004627507703580716m",
        orbit: "10.89188deg 119.9775deg 0.03543022m",
        target: "-0.1053838m 0.01610652m 0.1076345m"
      },
    ]
  },
  {
    id: 8,
    name: "Modern Sofa",
    modelSrc: sofa,
    iOSSrc: sofaUsdz,
    category: "Furniture",
    color: "Gray",
    price: "599.99",
    rating: "4.7",
    description: "Luxurious 3-seater sofa with plush cushions and contemporary design",
    image: "/sofa.jpg",
    inStock: true,
    verified: true,
    colorOptions: ["Gray", "Beige", "Navy Blue", "Charcoal"],
    annotations: [
      {
        title: "comfortable-cushions",
        slot: "hotspot-1",
        position: "0.011597651675006926m 0.5744572599492905m -0.1383899854988515m",
        normal: "0.028332494851243895m 0.2137467602998606m 0.9764781575625839m",
        orbit: "10.89188deg 119.9775deg 0.03543022m",
        target: "-0.1053838m 0.01610652m 0.1076345m"
      }, 
      {
        title: "sturdy-frame",
        slot: "hotspot-2",
        position: "0.008754174027053235m 0.3513235856998005m 0.1658749505478343m",
        normal: "-0.30988561688489596m 0.9507625837296717m -0.004627507703580716m",
        orbit: "10.89188deg 119.9775deg 0.03543022m",
        target: "-0.1053838m 0.01610652m 0.1076345m"
      },
    ]
  },
  {
    id: 9,
    name: "Office Desk",
    modelSrc: table,
    iOSSrc: tableUsdz,
    category: "Furniture",
    color: "Walnut",
    price: "199.99",
    rating: "4.4",
    description: "Elegant office desk with solid wood construction and modern design",
    image: "/office-desk.jpg",
    inStock: true,
    verified: true,
    colorOptions: ["Walnut", "Oak", "White", "Black"],
    annotations: [
      {
        title: "solid-surface",
        slot: "hotspot-1",
        position: "0.011597651675006926m 0.5744572599492905m -0.1383899854988515m",
        normal: "0.028332494851243895m 0.2137467602998606m 0.9764781575625839m",
        orbit: "10.89188deg 119.9775deg 0.03543022m",
        target: "-0.1053838m 0.01610652m 0.1076345m"
      }, 
      {
        title: "wooden-legs",
        slot: "hotspot-2",
        position: "0.008754174027053235m 0.3513235856998005m 0.1658749505478343m",
        normal: "-0.30988561688489596m 0.9507625837296717m -0.004627507703580716m",
        orbit: "10.89188deg 119.9775deg 0.03543022m",
        target: "-0.1053838m 0.01610652m 0.1076345m"
      },
    ]
  },
  {
    id: 10,
    name: "Modern Table Lamp",
    modelSrc: tableLamp,
    iOSSrc: tableLampUsdz,
    category: "Lighting",
    color: "Gold",
    price: "89.99",
    rating: "4.6",
    description: "Stylish table lamp with adjustable brightness and warm LED lighting",
    image: "/lamp.jpg",
    inStock: true,
    verified: true,
    colorOptions: ["Gold", "Silver", "Black", "White"],
    annotations: [
      {
        title: "adjustable-light",
        slot: "hotspot-1",
        position: "0.011597651675006926m 0.5744572599492905m -0.1383899854988515m",
        normal: "0.028332494851243895m 0.2137467602998606m 0.9764781575625839m",
        orbit: "10.89188deg 119.9775deg 0.03543022m",
        target: "-0.1053838m 0.01610652m 0.1076345m"
      }, 
      {
        title: "stable-base",
        slot: "hotspot-2",
        position: "0.008754174027053235m 0.3513235856998005m 0.1658749505478343m",
        normal: "-0.30988561688489596m 0.9507625837296717m -0.004627507703580716m",
        orbit: "10.89188deg 119.9775deg 0.03543022m",
        target: "-0.1053838m 0.01610652m 0.1076345m"
      },
    ]
  },
  {
    id: 11,
    name: "Book Self",
    modelSrc: bookSelf,
    iOSSrc: bookSelfUsdz,
    category: "Furniture",
    color: "Oak",
    price: "279.99",
    rating: "4.7",
    description: "Modern bookshelf with multiple tiers for books and decorative items",
    image: "/bookself.jpg",
    inStock: true,
    verified: true,
    colorOptions: ["Oak", "Walnut", "White", "Black"],
    annotations: [
      {
        title: "sturdy-shelves",
        slot: "hotspot-1",
        position: "0.011597651675006926m 0.5744572599492905m -0.1383899854988515m",
        normal: "0.028332494851243895m 0.2137467602998606m 0.9764781575625839m",
        orbit: "10.89188deg 119.9775deg 0.03543022m",
        target: "-0.1053838m 0.01610652m 0.1076345m"
      }, 
      {
        title: "anti-tip-design",
        slot: "hotspot-2",
        position: "0.008754174027053235m 0.3513235856998005m 0.1658749505478343m",
        normal: "-0.30988561688489596m 0.9507625837296717m -0.004627507703580716m",
        orbit: "10.89188deg 119.9775deg 0.03543022m",
        target: "-0.1053838m 0.01610652m 0.1076345m"
      },
    ]
  },
  {
    id: 12,
    name: "Queen Size Bed",
    modelSrc: bed,
    iOSSrc: bedUsdz,
    category: "Furniture",
    color: "White",
    price: "799.99",
    rating: "4.8",
    description: "Comfortable queen-size bed with upholstered headboard and solid frame",
    image: "/bed.jpg",
    inStock: true,
    verified: true,
    colorOptions: ["White", "Gray", "Beige", "Navy"],
    annotations: [
      {
        title: "padded-headboard",
        slot: "hotspot-1",
        position: "0.011597651675006926m 0.5744572599492905m -0.1383899854988515m",
        normal: "0.028332494851243895m 0.2137467602998606m 0.9764781575625839m",
        orbit: "10.89188deg 119.9775deg 0.03543022m",
        target: "-0.1053838m 0.01610652m 0.1076345m"
      }, 
      {
        title: "solid-frame",
        slot: "hotspot-2",
        position: "0.008754174027053235m 0.3513235856998005m 0.1658749505478343m",
        normal: "-0.30988561688489596m 0.9507625837296717m -0.004627507703580716m",
        orbit: "10.89188deg 119.9775deg 0.03543022m",
        target: "-0.1053838m 0.01610652m 0.1076345m"
      },
    ]
  },
  {
    id: 13,
    name: "Simple Dining Table",
    modelSrc: simpleDiningTable,
    iOSSrc: simpleDiningTableUsdz,
    category: "Furniture",
    color: "Natural Wood",
    price: "499.99",
    rating: "4.6",
    description: "Minimalist dining table perfect for 4-6 people with clean lines",
    image: "/diningtable.jpg",
    inStock: true,
    verified: true,
    colorOptions: ["Natural Wood", "Dark Walnut", "White Oak", "Espresso"],
    annotations: [
      {
        title: "spacious-surface",
        slot: "hotspot-1",
        position: "0.011597651675006926m 0.5744572599492905m -0.1383899854988515m",
        normal: "0.028332494851243895m 0.2137467602998606m 0.9764781575625839m",
        orbit: "10.89188deg 119.9775deg 0.03543022m",
        target: "-0.1053838m 0.01610652m 0.1076345m"
      }, 
      {
        title: "durable-construction",
        slot: "hotspot-2",
        position: "0.008754174027053235m 0.3513235856998005m 0.1658749505478343m",
        normal: "-0.30988561688489596m 0.9507625837296717m -0.004627507703580716m",
        orbit: "10.89188deg 119.9775deg 0.03543022m",
        target: "-0.1053838m 0.01610652m 0.1076345m"
      },
    ]
  },
  {
    id: 14,
    name: "Game Ready Carpet",
    modelSrc: carpet,
    iOSSrc: carpetUsdz,
    category: "Decor",
    color: "Multi",
    price: "159.99",
    rating: "4.4",
    description: "High-quality decorative carpet with intricate patterns, perfect for living spaces",
    image: "/carpet.jpg",
    inStock: true,
    verified: true,
    colorOptions: ["Multi", "Blue", "Red", "Beige", "Gray"],
    annotations: [
      {
        title: "intricate-pattern",
        slot: "hotspot-1",
        position: "0.011597651675006926m 0.5744572599492905m -0.1383899854988515m",
        normal: "0.028332494851243895m 0.2137467602998606m 0.9764781575625839m",
        orbit: "10.89188deg 119.9775deg 0.03543022m",
        target: "-0.1053838m 0.01610652m 0.1076345m"
      }, 
      {
        title: "soft-texture",
        slot: "hotspot-2",
        position: "0.008754174027053235m 0.3513235856998005m 0.1658749505478343m",
        normal: "-0.30988561688489596m 0.9507625837296717m -0.004627507703580716m",
        orbit: "10.89188deg 119.9775deg 0.03543022m",
        target: "-0.1053838m 0.01610652m 0.1076345m"
      },
    ]
  },
  {
    id: 15,
    name: "Wall Mirror",
    modelSrc: mirror,
    iOSSrc: mirrorUsdz,
    category: "Decor",
    color: "Silver",
    price: "129.99",
    rating: "4.5",
    description: "Large decorative wall mirror with modern minimalist frame",
    image: "/mirror.jpg",
    inStock: true,
    verified: true,
    colorOptions: ["Silver", "Gold", "Black", "White"],
    annotations: [
      {
        title: "sleek-frame",
        slot: "hotspot-1",
        position: "0.011597651675006926m 0.5744572599492905m -0.1383899854988515m",
        normal: "0.028332494851243895m 0.2137467602998606m 0.9764781575625839m",
        orbit: "10.89188deg 119.9775deg 0.03543022m",
        target: "-0.1053838m 0.01610652m 0.1076345m"
      }, 
      {
        title: "clear-reflection",
        slot: "hotspot-2",
        position: "0.008754174027053235m 0.3513235856998005m 0.1658749505478343m",
        normal: "-0.30988561688489596m 0.9507625837296717m -0.004627507703580716m",
        orbit: "10.89188deg 119.9775deg 0.03543022m",
        target: "-0.1053838m 0.01610652m 0.1076345m"
      },
    ]
  },
  {
    id: 16,
    name: "MacBook Laptop",
    modelSrc: macbook,
    iOSSrc: macbookUsdz,
    category: "Electronics",
    color: "Space Gray",
    price: "99.99",
    rating: "4.9",
    description: "High-performance laptop with sleek design, perfect for work and entertainment",
    image: "/macbook.jpg",
    inStock: true,
    verified: true,
    colorOptions: ["Space Gray", "Silver", "Gold"],
    annotations: [
      {
        title: "retina-display",
        slot: "hotspot-1",
        position: "0.011597651675006926m 0.5744572599492905m -0.1383899854988515m",
        normal: "0.028332494851243895m 0.2137467602998606m 0.9764781575625839m",
        orbit: "10.89188deg 119.9775deg 0.03543022m",
        target: "-0.1053838m 0.01610652m 0.1076345m"
      }, 
      {
        title: "aluminum-body",
        slot: "hotspot-2",
        position: "0.008754174027053235m 0.3513235856998005m 0.1658749505478343m",
        normal: "-0.30988561688489596m 0.9507625837296717m -0.004627507703580716m",
        orbit: "10.89188deg 119.9775deg 0.03543022m",
        target: "-0.1053838m 0.01610652m 0.1076345m"
      },
    ]
  },
  {
    id: 17,
    name: "Wooden Almirah",
    modelSrc: woodenAlmirah,
    iOSSrc: woodenAlmirahUsdz,
    category: "Furniture",
    color: "Natural Wood",
    price: "899.99",
    rating: "4.8",
    description: "Spacious wooden wardrobe with classic design and ample storage",
    image: "/almirah.jpg",
    inStock: true,
    verified: true,
    colorOptions: ["Natural Wood", "Dark Walnut", "Mahogany", "White"],
    annotations: [
      {
        title: "spacious-interior",
        slot: "hotspot-1",
        position: "0.011597651675006926m 0.5744572599492905m -0.1383899854988515m",
        normal: "0.028332494851243895m 0.2137467602998606m 0.9764781575625839m",
        orbit: "10.89188deg 119.9775deg 0.03543022m",
        target: "-0.1053838m 0.01610652m 0.1076345m"
      }, 
      {
        title: "solid-construction",
        slot: "hotspot-2",
        position: "0.008754174027053235m 0.3513235856998005m 0.1658749505478343m",
        normal: "-0.30988561688489596m 0.9507625837296717m -0.004627507703580716m",
        orbit: "10.89188deg 119.9775deg 0.03543022m",
        target: "-0.1053838m 0.01610652m 0.1076345m"
      },
    ]
  },
  {
    id: 18,
    name: "Premium Office Chair",
    modelSrc: officeChairNew,
    iOSSrc: officeChairNewUsdz,
    category: "Furniture",
    color: "Black",
    price: "189.99",
    rating: "4.9",
    description: "High-end ergonomic office chair with advanced lumbar support and breathable mesh",
    image: "/office_chair.jpg",
    inStock: true,
    verified: true,
    colorOptions: ["Black", "Gray", "White", "Blue"],
    annotations: [
      {
        title: "ergonomic-design",
        slot: "hotspot-1",
        position: "0.011597651675006926m 0.5744572599492905m -0.1383899854988515m",
        normal: "0.028332494851243895m 0.2137467602998606m 0.9764781575625839m",
        orbit: "10.89188deg 119.9775deg 0.03543022m",
        target: "-0.1053838m 0.01610652m 0.1076345m"
      }, 
      {
        title: "breathable-mesh",
        slot: "hotspot-2",
        position: "0.008754174027053235m 0.3513235856998005m 0.1658749505478343m",
        normal: "-0.30988561688489596m 0.9507625837296717m -0.004627507703580716m",
        orbit: "10.89188deg 119.9775deg 0.03543022m",
        target: "-0.1053838m 0.01610652m 0.1076345m"
      },
    ]
  },
  // ✅ NEW PRODUCT 1: Memorial Monument Sculpture (Art Category)
  {
    id: 19,
    name: "Memorial Monument Sculpture",
    modelSrc: kriegerdenkmal,
    iOSSrc: kriegerdenkmalUsdz,
    category: "Art",
    color: "Stone Gray",
    price: "349.99",
    rating: "4.8",
    description: "Elegant monument sculpture with detailed craftsmanship, perfect for gardens or memorial spaces",
    image: "/kriegerdenkmal.jpg",
    inStock: true,
    verified: true,
    colorOptions: ["Stone Gray", "White Marble", "Bronze", "Black Granite"],
    annotations: [
      {
        title: "detailed-craftsmanship",
        slot: "hotspot-1",
        position: "0.011597651675006926m 0.5744572599492905m -0.1383899854988515m",
        normal: "0.028332494851243895m 0.2137467602998606m 0.9764781575625839m",
        orbit: "10.89188deg 119.9775deg 0.03543022m",
        target: "-0.1053838m 0.01610652m 0.1076345m"
      }, 
      {
        title: "weather-resistant",
        slot: "hotspot-2",
        position: "0.008754174027053235m 0.3513235856998005m 0.1658749505478343m",
        normal: "-0.30988561688489596m 0.9507625837296717m -0.004627507703580716m",
        orbit: "10.89188deg 119.9775deg 0.03543022m",
        target: "-0.1053838m 0.01610652m 0.1076345m"
      },
    ]
  },
  // ✅ NEW PRODUCT 2: Double Door Refrigerator (Electronics Category)
  {
    id: 20,
    name: "Double Door Refrigerator",
    modelSrc: refrigerator,
    iOSSrc: refrigeratorUsdz,
    category: "Electronics",
    color: "Stainless Steel",
    price: "899.99",
    rating: "4.9",
    description: "Modern double-door refrigerator with spacious compartments and smart cooling technology",
    image: "/refrigerator.jpg",
    inStock: true,
    verified: true,
    colorOptions: ["Stainless Steel", "Black", "White", "Silver"],
    annotations: [
      {
        title: "spacious-storage",
        slot: "hotspot-1",
        position: "0.011597651675006926m 0.5744572599492905m -0.1383899854988515m",
        normal: "0.028332494851243895m 0.2137467602998606m 0.9764781575625839m",
        orbit: "10.89188deg 119.9775deg 0.03543022m",
        target: "-0.1053838m 0.01610652m 0.1076345m"
      }, 
      {
        title: "smart-cooling",
        slot: "hotspot-2",
        position: "0.008754174027053235m 0.3513235856998005m 0.1658749505478343m",
        normal: "-0.30988561688489596m 0.9507625837296717m -0.004627507703580716m",
        orbit: "10.89188deg 119.9775deg 0.03543022m",
        target: "-0.1053838m 0.01610652m 0.1076345m"
      },
    ]
  },
  // ✅ NEW PRODUCT 3: Smart Drum Washing Machine (Electronics Category)
  {
    id: 21,
    name: "Smart Drum Washing Machine",
    modelSrc: washingMachine,
    iOSSrc: washingMachineUsdz,
    category: "Electronics",
    color: "White",
    price: "649.99",
    rating: "4.7",
    description: "Energy-efficient front-load washing machine with smart features and large capacity",
    image: "/washing_machine.jpg",
    inStock: true,
    verified: true,
    colorOptions: ["White", "Silver", "Black"],
    annotations: [
      {
        title: "large-drum-capacity",
        slot: "hotspot-1",
        position: "0.011597651675006926m 0.5744572599492905m -0.1383899854988515m",
        normal: "0.028332494851243895m 0.2137467602998606m 0.9764781575625839m",
        orbit: "10.89188deg 119.9775deg 0.03543022m",
        target: "-0.1053838m 0.01610652m 0.1076345m"
      }, 
      {
        title: "energy-efficient",
        slot: "hotspot-2",
        position: "0.008754174027053235m 0.3513235856998005m 0.1658749505478343m",
        normal: "-0.30988561688489596m 0.9507625837296717m -0.004627507703580716m",
        orbit: "10.89188deg 119.9775deg 0.03543022m",
        target: "-0.1053838m 0.01610652m 0.1076345m"
      },
    ]
  }
];

export default productItems;
